export const PODBORKI_LIST_API_URL =
  "https://api.portal.idc.md/api/adm/genreList";

export const PODBORKI_CREATE_API_URL =
  "https://api.portal.idc.md/api/adm/genreAdd";

export const PODBORKI_AVAILABLE_API_URL =
  "https://api.portal.idc.md/api/listGenre";

export const getFilmPodborkaChangeApiUrl = (
  filmId: number,
  podborkaId: number,
  status: 0 | 1
) =>
  `https://api.portal.idc.md/api/adm/filmGenreChange/${filmId}/${podborkaId}/${status}`;

export const PODBORKI_IMAGE_BASE_URL =
  "https://portal.idc.md/img/mov-selec";

export const getPodborkaDetailsApiUrl = (id: number) =>
  `https://api.portal.idc.md/api/adm/genre/${id}`;

export const getPodborkaMoviesApiUrl = (id: number, page = 1) =>
  `https://api.portal.idc.md/api/file/category/${id}/24?page=${page}&id_sort=1`;

// Временный токен старого API. Удалить после перехода на новый сервис.
export const PODBORKI_API_TOKEN =
  "62d0b580-cc6e-11f1-9db2-9954b10289cd";
